import { IUpdatable } from './../../../observer/IUpdatable';
import { BasicController } from "../../controller/BasicController";

import EventDispatcher = createjs.EventDispatcher;

export class BasicData extends EventDispatcher implements IUpdatable {
    protected _updateData: boolean = true;
    protected _nextUpdateInterval: number = 0;
    protected _updateInterval: number = 1000;

    constructor() {
        super();
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    public get updateInterval(): number {
        return this._updateInterval;
    }

    public set updateInterval(value: number) {
        this._updateInterval = value;
    }

    public get updateData(): boolean {
        return this._updateData;
    }

    public set updateData(value: boolean) {
        this._updateData = value;
    }

    public update(now: number): void {
        if (now > this._nextUpdateInterval) {
            this._nextUpdateInterval = now + this._updateInterval;
            this.executeUpdate(now);
        }
    }

    public executeUpdate(now: number): void {
    }

    public destroy(): void {

    }
}

